import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import "../Signup.css"
const host = process.env.REACT_APP_BASE_URL;
export default function SignUp(props) {
    const navigate = useNavigate();
    const [credentials, setcredentials] = useState({ name: "", email: "", password: "", cpassword: "" });
    const handlesubmit = async (e) => {
        props.setprogress(50)
        e.preventDefault();
        const response = await fetch(`${host}/api/auth/adduser`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ name: credentials.name, email: credentials.email, password: credentials.password })
        });
        const json = await response.json();
        props.setprogress(80)
        console.log(json);
        if (json.success) {
            localStorage.setItem('token', json.auth_token)
            navigate('/');
            props.setprogress(100)
        }
        else {
            alert("Invalid Credentials");
        }
    }

    const onChange = (e) => {
        setcredentials({ ...credentials, [e.target.name]: e.target.value })
    }
    return (
        <div className="login-page">
            <div className="form">
                <div className="login">
                    <div className="login-header">
                        <h3>Register</h3>
                        <p>Please enter your credentials to register.</p>
                    </div>
                </div>
                <form className="login-form">
                    <input type="text" required onChange={onChange} value={credentials.name} name="name" id="name" placeholder="UserName" />
                    <input type="email" value={credentials.email} id="email" name="email" onChange={onChange} placeholder="Email" />
                    <input type="password" value={credentials.password} name="password" required id="password" onChange={onChange} placeholder="Password" />
                    <input type="password" onChange={onChange} value={credentials.cpassword} name="cpassword" id="cpassword" placeholder="Confirm Password" />
                    <button type="submit" onClick={handlesubmit} className={`btn bt-lg bg-dark text-light rounded-pill my-2 ${credentials.cpassword === credentials.password ? "" : "disabled"}`}>Sign Up</button>
                    <p className="message">Already registered? <Link to="/login">Login</Link></p>
                </form>
            </div>
        </div>
    );
}
